export default __webpack_public_path__ + "nz.png";